import { push } from "connected-react-router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as environmentActions } from "reducers/environment";
import { actions as modalActions } from "reducers/modal";

export const useComplementaryDataSelectors = (setError) => {
    const dispatch = useDispatch();
    const [countryListComplementaryData, setCountryListComplementaryData] = useState([
        { value: "1", label: "Argentina" },
    ]);
    const [fatcaCategoryList, setFatcaCategoryList] = useState([{ value: "1", label: "Persona Jurídica Exenta" }]);
    const [crsOrOcdeCategoryList, setCrsOrOcdeCategoryList] = useState([{ value: "1", label: "Exentos" }]);
    const [juridicForm, setJuridicForm] = useState("OTROS");

    const complementaryDataselectorsRequest = useSelector(
        (state) => state.environment.complementaryDataSelectorsRequest,
    );
    const _documentNumber = useSelector(
        (state) => state.environment?.currentStepRequest?.value?.onboardingData?.documentNumber,
    );

    const cuit = useSelector((state) => state.environment?.generalDataSelectorsRequest?.value?.documentNumber);

    const _cuit = useSelector((state) => state.environment?.generalDataBackup?.cuit);

    const documentNumber = cuit || _documentNumber || _cuit;

    const {
        status: complementaryDataSelectorsStatus,
        value: complementaryDataSelectorsValue,
        error: complementaryDataSelectorsError,
    } = complementaryDataselectorsRequest;

    useEffect(() => {
        if (documentNumber) {
            dispatch(environmentActions.getComplementaryDataSelectors(documentNumber));
        }
    }, [documentNumber]);

    useEffect(() => {
        // complementaryDataselectorsRequest
        if (complementaryDataSelectorsStatus === "SUCCESS") {
            setCountryListComplementaryData(
                complementaryDataSelectorsValue?.countrySelector?.reduce(
                    (newList, { id, name }) => [...newList, { value: id, label: name }],
                    [],
                ),
            );
            setFatcaCategoryList(
                complementaryDataSelectorsValue?.categoriesFATCASelector?.reduce(
                    (newList, { stringId, shortDesc }) => [...newList, { value: stringId, label: shortDesc }],
                    [],
                ),
            );
            setCrsOrOcdeCategoryList(
                complementaryDataSelectorsValue?.categoriesCRSOCDESelector?.reduce(
                    (newList, { stringId, shortDesc }) => [...newList, { value: stringId, label: shortDesc }],
                    [],
                ),
            );
            setJuridicForm(
                complementaryDataSelectorsValue?.legalPersonCDA?.acceptanceCriteria?.find(
                    (item) => item?.name === "VI_TipoSocietario",
                )?.value || "OTROS",
            );
        } else if (complementaryDataSelectorsStatus === "FAILURE") {
            dispatch(push("/environment/stepError"));
            setError(complementaryDataSelectorsError);
            dispatch(modalActions.modalShow());
        }
    }, [complementaryDataSelectorsStatus, complementaryDataSelectorsValue, complementaryDataSelectorsError]);

    useEffect(() => {
        if (complementaryDataSelectorsError) {
            setError(complementaryDataSelectorsError);
            dispatch(modalActions.modalShow());
        }
    }, [complementaryDataSelectorsError]);

    return {
        complementaryDataSelectorsStatus,
        complementarySelectors: {
            countryListComplementaryData,
            fatcaCategoryList,
            crsOrOcdeCategoryList,
            juridicForm,
        },
    };
};

export default useComplementaryDataSelectors;
